











import Vue from 'vue';
const Props = Vue.extend({
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: 'Chargement en cours'
		}
	}
});

export default class CustomLoader extends Props {}
